import { useSearchParams } from 'react-router';

import { ExportType } from '@/domain/pdf-reports/pdf-reports.type';

import { PdfFestivalPage1 } from './pages/PdfProjectFestivalP1';
import { PdfFestivalPage2 } from './pages/PdfProjectFestivalP2';
import { PdfFestivalPage3 } from './pages/PdfProjectFestivalP3';
import { PdfFestivalPage4 } from './pages/PdfProjectFestivalP4';
import { PdfFestivalPage5 } from './pages/PdfProjectFestivalP5';

export function PdfProjectFestival() {
  const [searchParams] = useSearchParams();
  const exportType = searchParams.get('export_type');
  const totalPages: number = 4;

  return (
    <>
      <PdfFestivalPage1 totalPages={totalPages} />
      <PdfFestivalPage2 totalPages={totalPages} />
      <PdfFestivalPage3 totalPages={totalPages} />
      <PdfFestivalPage4 totalPages={totalPages} />
      {exportType === ExportType.FULL_ANSWER_AND_RESULTS && (
        <PdfFestivalPage5 totalPages={totalPages} />
      )}
    </>
  );
}
